<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" x-small text @click.stop="cancelAppointment"
        ><v-icon small>mdi-close</v-icon></v-btn
      >
    </template>
    <span> Cancel </span>
    <confirm-modal ref="confirm"></confirm-modal>
  </v-tooltip>
</template>

<script>
import ConfirmModal from "../Shared/confirm-modal";

export default {
  components: {
    ConfirmModal,
  },
  props: ["appointmentId"],
  methods: {
    cancelAppointment: async function () {
      if (
        await this.$refs.confirm.open(
          "Are you sure you want to cancel this appointment?",
          "",
          "Cancel"
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        var message = await this.$store.dispatch(
          "appointmentsModule/cancelAppointment",
          this.appointmentId
        );
        this.$store.commit("uxModule/setShowLoader", false);

        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      }
    },
  },
};
</script>
